module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAKBAMAAABcR4NbAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUAAAA2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM2PEM18WfKAAAADnRSTlMAbfxuRu/wKNsSvb4FmBSiEtAAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAARElEQVQI12MQegcHygwscTD2MwcGhgoYp52BgYFzHYT9egKQw3AWwrnDAAZCEN0QADIDpBsCKiC6IYBzH0Q3BJyF6AYATEw4AwIw9VsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/down-grey3@2x.png
// module id = 775
// module chunks = 0 1 2 3 4